import React, { useEffect, useState } from "react";
import Head from "next/head";
import { Header, Footer, BreadCrumbsComponent } from "app";
import { useRouter } from "next/router";
import { SectionContainerBase, TwoColumnSectionBase } from "@reusejs/react";
import { XIcon } from "@heroicons/react/outline";
import DashboardSidebar from "./DashboardSidebar";
import DashboardWrapper from "../../hoc/DashboardWrapper";
import { useSelector } from "react-redux";
import { updateUser, getAllProperties, getUser } from "services";

export default function DashboardLayout(props: any) {
  const router = useRouter();
  const userProfile = useSelector((state: any) => {
    return state.auth?.user?.profile;
  });
  const shortlistedProperties = useSelector((state: any) => {
    return state.auth?.user?.profile?.meta?.shortlisted_properties;
  });

  useEffect(() => {
    checkShortlistedPropertiesExists();
  }, []);

  const checkShortlistedPropertiesExists = async () => {
    const data: any = await getAllProperties({
      apiConfig: {
        includeRelations: [],
        includeMutations: [],
        includeFacets: false,
      },
      limitBy: {
        per_page: 100,
        page: 1,
      },
      sortBy: [],
      filterBy: [
        {
          attribute: "uuid",
          op: "in",
          value: shortlistedProperties ? shortlistedProperties : [],
        },
      ],
    });

    let propertyIds: any = [];
    data.data.map((item: any) => {
      propertyIds.push(item.uuid);
    });

    const unmatchedIds =
      shortlistedProperties &&
      shortlistedProperties.filter(
        (item: any) => !propertyIds.some((element: any) => item === element)
      );

    const filteredItems =
      shortlistedProperties &&
      shortlistedProperties.filter((item: any) => !unmatchedIds.includes(item));
    const user: any = await getUser();

    await updateUser({
      profile_picture: userProfile?.profile_picture,
      bio: user.profile?.bio, //userProfile?.bio,
      meta: {
        shortlisted_properties: filteredItems,
      },
    });
  };

  return (
    <DashboardWrapper>
      <div className="min-h-screen">
        <Head>
          <title>Auction Bazaar - Dashboard</title>
          <link rel="icon" href="/favicon.ico" />
        </Head>
        <Header />
        {/* <div className="py-4 px-4 sm:px-6 bg-gray-50 border-b overflow-hidden">
          <div className="relative flex justify-between items-center max-w-xl mx-auto sm:max-w-7xl">
            <div className="relative text-xl font-semibold">
              {props.mainHeading}
            </div>
          </div>
        </div> */}
        <BreadCrumbsComponent
          firstLevel="Home"
          secondLevel="Shortlists"
          mainHeading="Shortlisted assets"
        />
        <SectionContainerBase
          sectionContainerBaseClasses={{
            outerContainerStyles: "pb-10 md:pb-20 bg-white overflow-hidden",
            innerContainerStyles:
              "relative max-w-7xl mx-auto px-4 sm:px-6 xl:px-0",
          }}
        >
          <TwoColumnSectionBase
            firstColumnEl={<DashboardSidebar />}
            secondColumnEl={<div>{props.children}</div>}
            twoColumnSectionBaseClasses={{
              firstElWrapperStyles: "hidden sm:block w-full h-screen md:w-1/4",
              secondElWrapperStyles: "w-full md:w-3/4 self-stretch md:pl-16",
              columnsFlexWrapperStyles:
                "flex items-start justify-between flex-col md:flex-row",
            }}
          />
        </SectionContainerBase>
        <Footer />
      </div>
    </DashboardWrapper>
  );
}
